import script from "./SpecialFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialFiles.vue?vue&type=script&setup=true&lang=js"

import "./SpecialFiles.vue?vue&type=style&index=0&id=a6d512d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6d512d2"]])

export default __exports__